import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchApiCredentials = async () => {
  const { data } = await apiClient.get('/api-integrations/credentials');
  return data;
};

export const useGetApiCredentialsHandler = () => {
  const dispatch = useDispatch();
  const [credentials, setCredentials] = useState(null);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['api-credentials'],
    queryFn: fetchApiCredentials,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (fetchedData) {
      setCredentials(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || error.message,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: 'Failed to fetch API credentials',
            severity: 'error',
          }),
        );
      }
    }
  }, [dispatch, error, isError]);

  return {
    credentials,
    isLoading,
  };
};
